import { App, ConfigProvider } from "antd";
import { FC, ReactNode } from "react";
import { ThemeProvider } from "styled-components";

import { useAppSelector } from "@/hooks/redux";
import {
    antdDarkTheme,
    antdLightTheme,
    darkTheme,
    GlobalStyle,
    lightTheme,
} from "@/theme";
import { Theme } from "@/types";

interface AppProvidersProps {
    children: ReactNode;
}

export const AppProviders: FC<AppProvidersProps> = ({ children }) => {
    const type = useAppSelector((s) => s.theme.type);

    const antdTheme = type === Theme.DARK ? antdDarkTheme : antdLightTheme;
    const theme = type === Theme.DARK ? darkTheme : lightTheme;

    return (
        <ThemeProvider theme={theme}>
            <ConfigProvider theme={antdTheme}>
                <App component={false}>
                    <GlobalStyle />
                    {children}
                </App>
            </ConfigProvider>
        </ThemeProvider>
    );
};
